<script setup lang="ts">
import type { Product } from "@shopware-pwa/types";
import type { EshopSetConfiguratorStepProduct } from "~/composables/shop/eShopSetConfiguratorTypes";
import ColorOptionCircleButton from "~/templates/elements/ColorOptionCircleButton.vue";

export interface ProductEshopsetColorOptionProps {
  stepProduct: EshopSetConfiguratorStepProduct;
}

const { stepProduct } = defineProps<ProductEshopsetColorOptionProps>();

const product = computed<Product>(() => stepProduct?.product as Product);
const option = computed(() =>
  product?.value?.options?.find(
    (configuratorOption) => configuratorOption.group?.displayType === "color",
  ),
);
const isOptionNotAvailable = computed(() => !stepProduct?.product?.available);
const isOptionSelected = computed(() => stepProduct?.selected);
</script>

<template>
  <ColorOptionCircleButton
    :is-option-not-available="isOptionNotAvailable"
    :is-option-selected="isOptionSelected"
    :option="option"
  />
</template>
